import * as React from 'react';

import {
  createStyles,
  Theme,
  Tooltip,
  Typography,
  WithStyles,
  withStyles,
  Zoom
} from '@material-ui/core';
import { InfoRounded } from '@material-ui/icons';

const styles = (theme: Theme) =>
  createStyles({
    infoBubble: {
      top: theme.spacing(2),
      right: theme.spacing(2),
      position: 'absolute'
    }
  });

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.grey[700]
  }
}))(Tooltip);

type IProps = WithStyles<typeof styles> & {
  title: string;
  body: React.ReactNode;
};

const InfoBubble: React.FC<IProps> = ({ classes, title, body }) => {
  return (
    <div className={classes.infoBubble}>
      <LightTooltip
        leaveTouchDelay={5000}
        enterTouchDelay={0}
        arrow
        TransitionComponent={Zoom}
        placement="top"
        title={
          <>
            <Typography color="inherit">{title}</Typography>
            <Typography variant="caption" color="inherit">
              {body}
            </Typography>
          </>
        }
      >
        <InfoRounded />
      </LightTooltip>
    </div>
  );
};

export default withStyles(styles)(InfoBubble);
